import { createContext, useContext, useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { useSite } from "../../context/SiteContext";
import Header from "./Header";
import Footer from "./Footer";

// TEST_BANNER / SITE_NOINDEX env vars on the backend drive these (no code change needed at launch).
const RobotsMeta = () => {
  const { noindex = true } = useSite();
  useEffect(() => {
    let m = document.querySelector('meta[name="robots"]');
    if (noindex && !m) { m = document.createElement("meta"); m.name = "robots"; m.content = "noindex, nofollow"; document.head.appendChild(m); }
    if (!noindex && m) m.remove();
  }, [noindex]);
  return null;
};

export const TestBanner = () => {
  const { test_mode, show_test_banner, test_banner_text } = useSite();
  if (!(show_test_banner ?? test_mode) || new URLSearchParams(window.location.search).has("verify")) return null;  // verification checkouts are real charges
  return (
    <div className="bg-gold px-4 py-1.5 text-center text-sm font-semibold text-navy" role="status" data-testid="test-mode-banner">
      {test_banner_text || "TEST MODE: registrations and payments are simulated. No real charges are made and no emails are sent."}
    </div>
  );
};

export const TheatreContext = createContext({ theatre: false, setTheatre: () => {} });
export const useTheatre = () => useContext(TheatreContext);

// Theatre mode hides the site chrome by state only, so the page content (and an embedded meeting) is never remounted.
export default function SiteLayout({ children, banner }) {
  const [theatre, setTheatre] = useState(false);
  return (
    <TheatreContext.Provider value={{ theatre, setTheatre }}>
    <div className="flex min-h-screen flex-col">
      <a href="#main" className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-50 focus:bg-white focus:px-4 focus:py-2" data-testid="skip-link">
        Skip to content
      </a>
      <RobotsMeta />
      {!theatre && banner}
      {!theatre && <TestBanner />}
      {!theatre && <Header />}
      <main id="main" className="flex-1">{children || <Outlet />}</main>
      {!theatre && <Footer />}
    </div>
    </TheatreContext.Provider>
  );
}
